import { TierPermissionPipe } from '@_pipes/tier-permission.pipe';
import { BehaviorService } from '@_services/Behavior.service';
import { MainAPiServiceService } from '@_services/main-api-service.service';
import {
  Component,
  OnInit,
  Input,
  OnDestroy,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Subject, Subscription, takeUntil } from 'rxjs';

@Component({
  selector: 'app-search-provider',
  templateUrl: './search-provider.component.html',
  styleUrls: ['./search-provider.component.scss'],
  providers: [TierPermissionPipe],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchProviderComponent implements OnInit, OnDestroy {
  @Input() SettingForm: FormGroup;
  isLoadingResults: boolean = false;
  @Input() errorWarningData: any;
  searchGstHanal: any = [];
  searchProvider: any = [];
  silqPayDrop: any = [];
  amlDrop: any = [];
  amlSecretDrop: any = [];
  hide: boolean = true;
  isspiner: boolean = false;
  emailSaveStrategy: any;
  isspinerInfo: boolean = false;
  UserList: any;
  class: boolean;
  sub: Subscription;
  sub1: Subscription;
  sub2: Subscription;
  emilSystem: any;
  emailSystemType: any = 'None';
  private _unsubscribeAll$: Subject<void> = new Subject();
  currentUser: any = JSON.parse(localStorage.getItem('currentUser'));

  constructor(
    private behaviorService: BehaviorService,
    public tierpermission: TierPermissionPipe,
    private _mainAPiServiceService: MainAPiServiceService,
    private toastr: ToastrService,
    private cd: ChangeDetectorRef,
  ) {}

  ngOnInit() {
    this.behaviorService.loadingSystemSetting('search-provider');
    this.loadData();
    this.loadIntegrations();
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
    this.sub1?.unsubscribe();
    this.sub2?.unsubscribe();
    this._unsubscribeAll$.next();
    this._unsubscribeAll$.complete();
  }

  /**
   * This function is used to load the data value
   */
  loadData(): void {
    this.sub = this.behaviorService.permissionCheckforHeight$
      .pipe(takeUntil(this._unsubscribeAll$))
      .subscribe((data: any) => {
        this.class = data;
        this.cd.markForCheck();
      });
    this.isLoadingResults = true;
    // this._mainAPiServiceService.getSetData({}, 'user').subscribe(response => {
    let data: any = {
      Filters: {
        ACTIVE: '1',
        AllData: false,
      },
      Action: 'GetData',
    };
    this.sub1 = this._mainAPiServiceService
      .getSetData(data, 'user')
      .pipe(takeUntil(this._unsubscribeAll$))
      .subscribe({
        next: (response: any) => {
          if (
            response.CODE === 200 &&
            (response.STATUS === 'OK' || response.STATUS === 'success')
          ) {
            if (response.DATA.USERS[0]) {
              this.UserList = response.DATA.USERS;
            }
          }
          this.isLoadingResults = false;
          this.cd.markForCheck();
        },
        error: (error: any) => {
          this.isLoadingResults = false;
          this.cd.markForCheck();
          // this.toastr.error(error);
        },
      });
    // this.GetFeeEarnerList();
    // this.pageSize = JSON.parse(localStorage.getItem('lastPageSize'));
  }

  /**
   * load the data of integrations
   */
  loadIntegrations() {
    this.isLoadingResults = true;
    this.sub2 = this._mainAPiServiceService
      .getSetData({ Action: 'GetData', Filters: { GroupName: 'Integrations' } }, 'system')
      .pipe(takeUntil(this._unsubscribeAll$))
      .subscribe({
        next: (response: any) => {
          if (response.CODE == 200 && response.STATUS == 'success') {
            this.isLoadingResults = false;
            let tempData: any = response.DATA.RECORDS;
            this.emilSystem = response.DATA.LISTS.EMAILSYSTEM;
            this.emailSaveStrategy = response.DATA.LISTS.EMAILSAVESTRATEGY;
            this.silqPayDrop = response.DATA.LISTS.PINPAYMENTSABSORBFEE;
            this.searchProvider = response.DATA.LISTS.SEARCHPROVIDER;
            this.searchGstHanal = response.DATA.LISTS.SEARCHGSTHANDLING;
            this.emailSystemType = tempData.EMAILSYSTEM;
            this.SettingForm.controls['XEROSTARTDATE'].setValue(tempData.XEROSTARTDATE);
            let XEROStartDateArray: any[] = tempData.XEROSTARTDATE.split('/');
            this.SettingForm.controls['XEROSTARTTEXTDATE'].setValue(
              new Date(
                XEROStartDateArray[1] + '/' + XEROStartDateArray[0] + '/' + XEROStartDateArray[2],
              ),
            );
            this.SettingForm.controls['EMAILSYSTEM'].setValue(tempData.EMAILSYSTEM);
            this.SettingForm.controls['EMAILSAVEFOLDER'].setValue(tempData.EMAILSAVEFOLDER);
            this.SettingForm.controls['EMAILATTACHMENTSAVEFOLDER'].setValue(
              tempData.EMAILATTACHMENTSAVEFOLDER,
            );
            this.SettingForm.controls['EMAILSAVESTRATEGY'].setValue(tempData.EMAILSAVESTRATEGY);
            this.SettingForm.patchValue({
              XEROINVOICEACCOUNT: tempData.XEROINVOICEACCOUNT,
              XERODONTSYNCEXPENSES: tempData.XERODONTSYNCEXPENSES,
              XERODONTSYNCINVOICES: tempData.XERODONTSYNCINVOICES,
              XEROORGANISATION: tempData.XEROORGANISATION,
              SEARCHPROVIDER: tempData.SEARCHPROVIDER,
              SEARCHDOWNLOADUSERGUID: tempData.SEARCHDOWNLOADUSERGUID,
              SEARCHUSERNAME: tempData.SEARCHUSERNAME,
              SEARCHPASSWORD: tempData.SEARCHPASSWORD,
              SEARCHGSTHANDLING: tempData.SEARCHGSTHANDLING,
              SEARCHURL: tempData.SEARCHURL,
              APLYIDKEY: tempData.APLYIDKEY,
              APLYIDSECRET: tempData.APLYIDSECRET,
              PINPAYMENTSAPIKEY: tempData.PINPAYMENTSAPIKEY,
              PINPAYMENTSABSORBFEE: tempData.PINPAYMENTSABSORBFEE,
              SILQPAYLINKDESC: tempData.SILQPAYLINKDESC,
              SILQPAYSHOWINVDETAILS: tempData.SILQPAYSHOWINVDETAILS,
              SILQPAYSHOWCHEQUEPAYMENT: tempData.SILQPAYSHOWCHEQUEPAYMENT,
              SILQPAYSHOWDDPAYMENT: tempData.SILQPAYSHOWDDPAYMENT,
              SILQPAYSHOWINVOICESTATEMENT1: tempData.SILQPAYSHOWINVOICESTATEMENT1,
              SILQPAYSHOWINVOICESTATEMENT2: tempData.SILQPAYSHOWINVOICESTATEMENT2,
              SILQPAYSHOWINVOICESTATEMENT3: tempData.SILQPAYSHOWINVOICESTATEMENT3,
              SILQPAYSHOWFEEAGRSTATEMENT: tempData.SILQPAYSHOWFEEAGRSTATEMENT,
              SILQPAYSHOWGLOBALFOOTER: tempData.SILQPAYSHOWGLOBALFOOTER,
            });
          }
          this.cd.markForCheck();
        },
        error: (error: any) => {
          this.toastr.error(error);
          this.isLoadingResults = false;
          this.cd.markForCheck();
        },
      });
  }

  /**
   * save the integrations data
   */
  saveIntegrations() {
    this.isspiner = true;
    let data: any = {
      GroupName: 'Integrations',
      SEARCHPROVIDER: this.SettingForm.controls['SEARCHPROVIDER'].value,
      SEARCHDOWNLOADUSERGUID: this.SettingForm.controls['SEARCHDOWNLOADUSERGUID'].value,
      SEARCHGSTHANDLING: this.SettingForm.controls['SEARCHGSTHANDLING'].value,
      SEARCHUSERNAME: this.SettingForm.controls['SEARCHUSERNAME'].value,
      SEARCHPASSWORD: this.SettingForm.controls['SEARCHPASSWORD'].value,
      SEARCHURL: this.SettingForm.controls['SEARCHURL'].value,
      XEROINVOICEACCOUNT: this.SettingForm.controls['XEROINVOICEACCOUNT'].value,
      XEROSTARTDATE: this.SettingForm.controls['XEROSTARTDATE'].value,
      XERODONTSYNCINVOICES: this.SettingForm.controls['XERODONTSYNCINVOICES'].value,
      XERODONTSYNCEXPENSES: this.SettingForm.controls['XERODONTSYNCEXPENSES'].value,
      XEROORGANISATION: this.SettingForm.controls['XEROORGANISATION'].value,
      PINPAYMENTSAPIKEY: this.SettingForm.controls['PINPAYMENTSAPIKEY'].value,
      APLYIDKEY: this.SettingForm.controls['APLYIDKEY'].value,
      APLYIDSECRET: this.SettingForm.controls['APLYIDSECRET'].value,
      PINPAYMENTSABSORBFEE: this.SettingForm.controls['PINPAYMENTSABSORBFEE'].value,
      SILQPAYLINKDESC: this.SettingForm.controls['SILQPAYLINKDESC'].value,
      SILQPAYSHOWINVDETAILS: this.SettingForm.controls['SILQPAYSHOWINVDETAILS'].value,
      SILQPAYSHOWCHEQUEPAYMENT: this.SettingForm.controls['SILQPAYSHOWCHEQUEPAYMENT'].value,
      SILQPAYSHOWDDPAYMENT: this.SettingForm.controls['SILQPAYSHOWDDPAYMENT'].value,
      SILQPAYSHOWINVOICESTATEMENT1: this.SettingForm.controls['SILQPAYSHOWINVOICESTATEMENT1'].value,
      SILQPAYSHOWINVOICESTATEMENT2: this.SettingForm.controls['SILQPAYSHOWINVOICESTATEMENT2'].value,
      SILQPAYSHOWINVOICESTATEMENT3: this.SettingForm.controls['SILQPAYSHOWINVOICESTATEMENT3'].value,
      SILQPAYSHOWFEEAGRSTATEMENT: this.SettingForm.controls['SILQPAYSHOWFEEAGRSTATEMENT'].value,
      SILQPAYSHOWGLOBALFOOTER: this.SettingForm.controls['SILQPAYSHOWGLOBALFOOTER'].value,
      EMAILSYSTEM: this.SettingForm.controls['EMAILSYSTEM'].value,
      EMAILSAVESTRATEGY: this.SettingForm.controls['EMAILSAVESTRATEGY'].value,
      EMAILATTACHMENTSAVEFOLDER: this.SettingForm.controls['EMAILATTACHMENTSAVEFOLDER'].value,
      EMAILSAVEFOLDER: this.SettingForm.controls['EMAILSAVEFOLDER'].value,
    };
    let data1: any = { Action: 'Update', Data: data };
    this._mainAPiServiceService
      .getSetData(data1, 'system')
      .pipe(takeUntil(this._unsubscribeAll$))
      .subscribe({
        next: (response: any) => {
          if (response.CODE == 200 && (response.STATUS == 'OK' || response.STATUS == 'success')) {
            this.isspiner = false;
            this.toastr.success('Updated successfully');
          } else if (
            (response.CODE == 451 || response.CODE == 450) &&
            response.STATUS == 'warning'
          ) {
            this.isspiner = false;
            this.toastr.warning(response.MESSAGE);
          } else if ((response.CODE == 450 || response.CODE == 451) && response.STATUS == 'error') {
            this.isspiner = false;
            this.toastr.warning(response.MESSAGE);
          } else {
            this.isspiner = false;
          }
          this.cd.markForCheck();
        },
        error: (error: any) => {
          this.isspiner = false;
          this.toastr.error(error);
          this.cd.markForCheck();
        },
      });
  }

  /**
   * save the info track data
   */
  saveInfoTrack() {
    this.isspinerInfo = true;
    let data: any = {
      GroupName: 'Integrations',
      SubgroupName: 'InfoTrack',
      SEARCHPROVIDER: this.SettingForm.controls['SEARCHPROVIDER'].value,
      SEARCHDOWNLOADUSERGUID: this.SettingForm.controls['SEARCHDOWNLOADUSERGUID'].value,
      SEARCHGSTHANDLING: this.SettingForm.controls['SEARCHGSTHANDLING'].value,
      SEARCHUSERNAME: this.SettingForm.controls['SEARCHUSERNAME'].value,
      SEARCHPASSWORD: this.SettingForm.controls['SEARCHPASSWORD'].value,
      SEARCHURL: this.SettingForm.controls['SEARCHURL'].value,
    };
    let data1: any = { Action: 'Update', Data: data };
    this._mainAPiServiceService
      .getSetData(data1, 'system')
      .pipe(takeUntil(this._unsubscribeAll$))
      .subscribe({
        next: (response: any) => {
          if (response.CODE == 200 && (response.STATUS == 'OK' || response.STATUS == 'success')) {
            this.isspinerInfo = false;
            this.toastr.success('Updated successfully');
          } else if (
            (response.CODE == 451 || response.CODE == 450) &&
            response.STATUS == 'warning'
          ) {
            this.isspinerInfo = false;
            this.toastr.warning(response.MESSAGE);
          } else if ((response.CODE == 450 || response.CODE == 451) && response.STATUS == 'error') {
            this.isspinerInfo = false;
            this.toastr.warning(response.MESSAGE);
          } else {
            this.isspinerInfo = false;
          }
          this.cd.markForCheck();
        },
        error: (error: any) => {
          this.isspinerInfo = false;
          this.toastr.error(error);
          this.cd.markForCheck();
        },
      });
  }
}
